module.exports = __webpack_public_path__ + "static/DSC_0912-3aff2677597fd44ebd112cb5c1648404.jpg";